/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Magnum_1_5lInputs */

const en_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const es_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const fr_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const de_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1,5L)`)
};

const ja_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マグナム (1.5L)`)
};

const zh_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大瓶装 (1.5L)`)
};

const ar_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ماغنوم (1.5 لتر)`)
};

const id_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const it_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const ru_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магнум (1.5л)`)
};

const pt_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnum (1.5L)`)
};

const ko_val_magnum_1_5l = /** @type {(inputs: Val_Magnum_1_5lInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`매그넘 (1.5L)`)
};

/**
* | output |
* | --- |
* | "Magnum (1.5L)" |
*
* @param {Val_Magnum_1_5lInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_magnum_1_5l = /** @type {((inputs?: Val_Magnum_1_5lInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Magnum_1_5lInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_magnum_1_5l(inputs)
	if (locale === "es") return es_val_magnum_1_5l(inputs)
	if (locale === "fr") return fr_val_magnum_1_5l(inputs)
	if (locale === "de") return de_val_magnum_1_5l(inputs)
	if (locale === "ja") return ja_val_magnum_1_5l(inputs)
	if (locale === "zh") return zh_val_magnum_1_5l(inputs)
	if (locale === "ar") return ar_val_magnum_1_5l(inputs)
	if (locale === "id") return id_val_magnum_1_5l(inputs)
	if (locale === "it") return it_val_magnum_1_5l(inputs)
	if (locale === "ru") return ru_val_magnum_1_5l(inputs)
	if (locale === "pt") return pt_val_magnum_1_5l(inputs)
	return ko_val_magnum_1_5l(inputs)
});